'use client';

import { Button } from '@zillow/constellation-10';
import { Bookmark } from 'lucide-react';

import { LucideIcon } from '@/src/components/LucideIcon';
import { useSrpSaveSearch } from './SrpSaveSearchProvider';

export function SrpSaveSearchButton() {
  const { isSaved, isDisabled, label, handleToggle } = useSrpSaveSearch();
  const handleClick = () => {
    if (!isDisabled) {
      handleToggle();
    }
  };

  return (
    <Button
      type="button"
      tone="brand"
      emphasis="outlined"
      size="sm"
      icon={<LucideIcon icon={Bookmark} size="sm" fill={isSaved ? 'currentColor' : 'none'} />}
      onClick={handleClick}
      disabled={isDisabled}
      aria-pressed={isSaved}
    >
      {label}
    </Button>
  );
}
